import React, { Component, Fragment } from "react";
import { properties } from '../../constants/Propertise';
import { Col, Tabs, Tab, Button, Modal, Table } from "react-bootstrap";
import { api } from '../../api/api';
import Overlay from '../Overlay';
import AlertMessages from '../AlertMessages';
import { CommonMethods } from '../Common/CommonMethod';
import { Input } from "reactstrap";
import InlineError from "../InlineError";

import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import ClientCaptcha from "react-client-captcha";
// import history from "../../history";
import { history } from "../../history";


class ResetPasswordPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            username: this.props.username,
            passwordDetails: {
                password: '',
                confirmPassword: '',
                captchaCode: ''
            },
            showPending: false,
            showError: false,
            showSucess: false,
            showButton: true,

            captchaCodeGenerated: '',

        }
    }


    handleChange = (event) => {
        this.setState(
            {
                passwordDetails: { ...this.state.passwordDetails, [event.target.name]: event.target.value }
            }
        );
    }

    validate = data => {
        const errors = {};
        if (!data.password) {
            errors.password = properties.newPasswordRequired;
        } else {
            let isvalidPassword = CommonMethods.checkPassword(data.password);
            if (isvalidPassword === false) {
                errors.password = properties.newPasswordNotMatchCriteria;
            }
        }
        if (!data.confirmPassword) {
            errors.confirmPassword = properties.confirmPasswordRequired;
        } else if (data.password !== data.confirmPassword) {
            errors.confirmPassword = properties.newConfirmPasswordSame;
        }
        if (!data.captchaCode) {
            errors.captchaCode = properties.captchaCodeReqText
        } else if (data.captchaCode !== this.state.captchaCodeGenerated) {
            errors.captchaCode = properties.captchaCodeValidReqText
        }

        return errors;
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = {
            username: this.props.username,
            password: this.state.passwordDetails.password.trim(),
            confirmPassword: this.state.passwordDetails.confirmPassword.trim(),
            captchaCode: this.state.passwordDetails.captchaCode
        }

        const errors = this.validate(formData);
        this.setState({ errors }, () => {
            if (Object.keys(errors).length === 0) {
                this.resetPassword(formData);
            }
        });
    }

    resetPassword = (forgetPasswordData) => {
        let requiredFormData = {
            username: forgetPasswordData.username,
            newPassword: forgetPasswordData.password
        }
        let resetPasswordUrl = process.env.REACT_APP_USERMANAGEMENT_API_URL + "forgotPassword/resetPassword";
        this.setState({
            showPending: true,
            showError: false,
            showSucess: false
        });
        api
            .post(resetPasswordUrl, requiredFormData)
            .then(resetPasswordResult => {
                if (resetPasswordResult.data !== undefined) {
                    if (resetPasswordResult.status === 200) {
                        if (resetPasswordResult.data === "Password-Reset Successful!") {
                            this.setState({
                                showPending: false,
                                showError: false,
                                showSucess: true,
                                message: "Password-Reset Successful!"
                            });
                        }
                    } else {
                        this.setState({
                            showPending: false,
                            showError: true,
                            showSucess: true
                        });
                    }
                } else {
                    this.setState({
                        showPending: false,
                        showError: true,
                        showSucess: true
                    });
                }
            })
            .catch(resetPasswordError => {
                this.setState({
                    showPending: false,
                    showError: true,
                    showSucess: true
                });
            });
    }

    componentDidMount() {
        // loadCaptchaEnginge(5, '#e0f2f1', 'black');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showSucess !== this.state.showSucess) {
            if (this.state.showSucess === true) {
                setTimeout(() => {
                    window.location.reload()
                    // this.props.closePopup()
                    // this.props.closeForgotPasswordOTPPopup()
                    history.push(`${process.env.PUBLIC_URL}/login`)
                }, 1000)
            }
        }
    }

    handleRefresh = (event) => {
        event.preventDefault();
        loadCaptchaEnginge(5, '#e0f2f1', 'black');
    }

    closeInPageAlertModel = () => {
        this.setState({
            showInPageAlertModel: false
        })
    }

    render() {

        return (
            <Fragment>
                <div className="mb-3">
                    {
                        (
                            this.state.showPending === true &&
                            this.state.showError === false &&
                            this.state.showSucess === false
                        ) &&
                        <div className="form-group col-md-12">
                            <div
                                className="alert alert-info alert-dismissible"
                                role="alert"
                                style={{ textAlign: "center" }}
                            >
                                {properties.pleaseWaitText}
                            </div>
                        </div>
                    }

                    {
                        (
                            this.state.showError === true &&
                            this.state.showSucess === true &&
                            this.state.showPending === false
                        ) &&
                        <div className="form-group col-md-12">
                            <div
                                className="alert alert-danger alert-dismissible"
                                role="alert"
                                style={{ textAlign: "center" }}
                            >
                                {properties.globalUserErrorMessage}
                            </div>
                        </div>
                    }

                    {
                        (
                            this.state.showError === false &&
                            this.state.showSucess === true &&
                            this.state.showPending === false
                        ) &&
                        <div className="form-group col-md-12">
                            <div
                                className="alert alert-success alert-dismissible"
                                role="alert"
                                style={{ textAlign: "center" }}
                            >
                                {properties.forgotpasswordChangeSucess}
                            </div>
                        </div>
                    }

                    <form onSubmit={this.handleSubmit.bind(this)}>

                        <div className="form-row">
                            <div className="col-md-10 mb-3">
                                <label>{properties.username} <span className="required" >*</span>:</label>
                                <Input
                                    disabled
                                    type="text"
                                    name="username"
                                    id="username"
                                    value={this.state.username}
                                    placeholder="Username"
                                />
                                {this.state.errors.username && <InlineError text={this.state.errors.username} />}
                            </div>

                            <div className="form-group col-md-10">
                                <label>{properties.newPasswordText} <span className="required" >*</span>:</label>
                                <Input
                                    type="password"
                                    className="form-control"
                                    name="password"
                                    value={this.state.passwordDetails.password}
                                    onChange={this.handleChange.bind(this)}
                                    placeholder={properties.newPasswordText}
                                />
                                {this.state.errors.password && <InlineError text={this.state.errors.password} />}
                            </div>

                            <div className="form-group col-md-10">
                                <label>{properties.confirmPasswordText} <span className="required" >*</span>:</label>
                                <Input
                                    type="password"
                                    className="form-control"
                                    name="confirmPassword"
                                    value={this.state.passwordDetails.confirmPassword}
                                    onChange={this.handleChange.bind(this)}
                                    placeholder={properties.confirmPasswordText}
                                />
                                {this.state.errors.confirmPassword && <InlineError text={this.state.errors.confirmPassword} />}
                            </div>

                            {/* <div className="col-md-12 row mx-0 justify-content-between align-items-center mb-3"> */}
                            {/* <div>
                                <LoadCanvasTemplateNoReload />
                                <span
                                    className="pe-7s-refresh pe-lg refrehCaptcha px-1"
                                    onClick={(e) => this.handleRefresh(e)}
                                    title="Refresh Captcha"
                                ></span>
                                <div className="col-md-6 px-0">
                                    <Input
                                        type="text"
                                        name="captchaCode"
                                        id="captchaCode"
                                        placeholder="Enter Captcha"
                                        onChange={this.handleChange}
                                    />
                                    {this.state.errors.captchaCode && <InlineError text={this.state.errors.captchaCode} />}
                                </div>
                            </div> */}

                            <div className="row">
                                <div className="col-md-6">
                                    <ClientCaptcha
                                        charsCount={5}
                                        backgroundColor="#4776a1"
                                        retryIconSize={25}
                                        height={38}
                                        refreshButton={false}
                                        // retryButtonClassName='retry'
                                        // retryIcon="pe-7s-refresh"
                                        captchaCode={code => {
                                            this.setState({
                                                captchaCodeGenerated: code
                                            })
                                        }} />
                                </div>
                                <div className="col-md-6">
                                    <Input
                                        type="text"
                                        name="captchaCode"
                                        id="captchaCode"
                                        placeholder="Enter Captcha"
                                        onChange={this.handleChange}
                                    />
                                    {this.state.errors.captchaCode && <InlineError text={this.state.errors.captchaCode} />}
                                </div>
                            </div>

                        </div>

                        {/* <div className="form-group col-md-12">
                        <hr />
                        {
                            (this.state.showButton === true) &&
                            <Button
                                onClick={this.handleSubmit}
                                className="btn btn-primary pull-right"
                            >
                                {properties.submitButtonText}
                            </Button>
                        }
                    </div> */}

                        <div className="divider" />
                        <div className="mb-3">
                            {
                                (this.state.showButton === true) &&
                                <button
                                    className="btn btn-primary pull-right"
                                    // type="submit"
                                    onClick={this.handleSubmit}
                                >
                                    {properties.submitButtonText}
                                </button>
                            }
                        </div>

                    </form>

                </div>

                <Overlay
                    openOverlay={this.state.showInPageAlertModel}
                    closeOverlay={this.closeInPageAlertModel}
                    className="alertData"
                >
                    <AlertMessages
                        isSucess={this.state.showSucess}
                        isPending={this.state.showPending}
                        apiError={this.state.showError}
                        showAlert={this.state.showInPageAlertModel}
                        closeAlert={this.closeInPageAlertModel}
                        message={this.state.message}
                    />
                </Overlay>
            </Fragment>
        );

    }
}

export default ResetPasswordPage;